<template>
	<svg :width="props.width" :height="props.height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			d="M6.46248 37.1479H43.5375C45.4914 37.1479 47.1 35.7255 47.1 33.9533V8.87C47.1 7.09784 45.4914 5.67539 43.5375 5.67539H6.46248C4.50857 5.67539 2.9 7.09784 2.9 8.87V33.9533C2.9 35.7255 4.50857 37.1479 6.46248 37.1479ZM3.96275 8.87C3.96275 7.6555 5.0747 6.64647 6.46248 6.64647H43.5375C44.9254 6.64647 46.0373 7.653 46.0373 8.87V33.9533C46.0373 35.1679 44.9281 36.1768 43.5375 36.1768H6.46248C5.07462 36.1768 3.96275 35.1703 3.96275 33.9533V8.87Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M3.43137 31.8848H46.5686C46.8517 31.8848 47.1 31.678 47.1 31.3992C47.1 31.1204 46.8517 30.9137 46.5686 30.9137H3.43137C3.14831 30.9137 2.9 31.1204 2.9 31.3992C2.9 31.678 3.14831 31.8848 3.43137 31.8848Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M18.4963 43.7121L18.4962 43.7124C18.4568 43.864 18.5012 44.0221 18.606 44.1399C18.7114 44.2584 18.8696 44.3242 19.0344 44.3242H30.9625H30.9656V44.3242C31.127 44.3233 31.2829 44.2573 31.3899 44.1412C31.5 44.0216 31.5396 43.8653 31.5009 43.7129L31.5007 43.7121L29.6351 36.6212L29.635 36.6207C29.5729 36.39 29.3459 36.2398 29.097 36.2398H20.9C20.651 36.2398 20.424 36.39 20.362 36.6207L20.3618 36.6212L18.4963 43.7121ZM30.2674 43.3307H19.7386L21.343 37.2333H28.6631L30.2674 43.3307Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M15.3727 27.4879C15.3727 27.7667 15.621 27.9734 15.904 27.9734C16.1871 27.9734 16.4354 27.7667 16.4354 27.4879V23.6941C16.4354 23.4153 16.1871 23.2086 15.904 23.2086C15.621 23.2086 15.3727 23.4153 15.3727 23.6941V27.4879Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M19.6187 27.6136C19.6187 27.8924 19.8671 28.0991 20.1501 28.0991C20.4332 28.0991 20.6815 27.8924 20.6815 27.6136V18.2449C20.6815 17.9661 20.4332 17.7594 20.1501 17.7594C19.8671 17.7594 19.6187 17.9661 19.6187 18.2449V27.6136Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M24.4703 27.4883C24.4703 27.7671 24.7186 27.9738 25.0017 27.9738C25.2847 27.9738 25.5331 27.7671 25.5331 27.4883V22.1473C25.5331 21.8684 25.2847 21.6617 25.0017 21.6617C24.7186 21.6617 24.4703 21.8684 24.4703 22.1473V27.4883Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M29.0172 27.4896C29.0172 27.7684 29.2655 27.9751 29.5486 27.9751C29.8316 27.9751 30.0799 27.7684 30.0799 27.4896V15.3348C30.0799 15.0559 29.8316 14.8492 29.5486 14.8492C29.2655 14.8492 29.0172 15.0559 29.0172 15.3348V27.4896Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
		<path
			d="M33.5641 27.4884C33.5641 27.7672 33.8124 27.9739 34.0954 27.9739C34.3785 27.9739 34.6268 27.7672 34.6268 27.4884V20.6746C34.6268 20.3958 34.3785 20.1891 34.0954 20.1891C33.8124 20.1891 33.5641 20.3958 33.5641 20.6746V27.4884Z"
			:fill="props.iconColor"
			:stroke="props.iconColor"
			stroke-width="0.2"
		/>
	</svg>
</template>
<script setup lang="ts">
const props = withDefaults(
	defineProps<{
		width?: string | number;
		height?: string | number;
		iconColor?: string;
	}>(),
	{
		width: 50,
		height: 50,
		iconColor: '#ffffff',
	}
);
</script>

<style lang="scss" scoped></style>
